<template>
    <div>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
        <nav-header></nav-header>
        <div class="projectdashboard-form validate-form p-l-50 p-r-50 p-t-10 p-b-80" >
            <section>
                <div class="page-title">
                    <h2>Dashboard</h2>
                </div>
                <hr/>
                <div class = "row">
                    <h4 id="project-name">{{nome_projeto}}</h4>
                    <button class="btn-secondary ml-3 text-left" id="project-edit-btn" v-b-modal.projectNameModal>
                        <i class="fa fa-pencil"></i>
                    </button>
                </div>
                <dashboard
                :companyId="companyId"
                :projectId="projectId"
                >
                </dashboard>
            </section>
            <b-modal
                    id="projectNameModal"
                    title="Alterar Nome do Projeto"
                    hide-footer
                >
                    <div class="input-container">
                        <input v-model="nome_projeto_edit" type="name" class="input-field"/>
                    </div>
                    <b-button @click="$bvModal.hide('projectNameModal')">Cancelar</b-button>
                    <b-button class="btn mr-1 btn-primary" @click="alterProjectName">Confirmar</b-button>
            </b-modal>
        </div>
        <user-profile-footer></user-profile-footer>
    </div>
    
</template>

<style scoped src="@/assets/css/util.css">
</style>

<style scoped>
    #project-edit-btn{
        border: none;
        color: white;
        padding: 5px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        margin: 4px 2px;
        border-radius: 8px;
    }
    .footer{
        z-index: 1;
    }
</style>

<script>
config
    import NavHeader from "../components/NavHeader.vue";
    import UserProfileFooter from '../components/UserProfileFooter.vue';
    import Dashboard from '../components/Dashboard.vue'
    import axios from 'axios';
    import config from "../helpers/generalConfig";

    export default {
         components: { NavHeader, UserProfileFooter, Dashboard},

         data() {
            return {
                nome_projeto: this.$route.params.nome_projeto,
                projectId: this.$route.params.projectId,
                companyId: this.$store.getters["auth/user"].CompanyId,
                nome_projeto_edit: '',
            }
        },

        methods: {
            alterProjectName() {
                 axios.put(`${config.jsonServer}/project`,{
                     id_projeto: this.projectId,
                     nome_projeto: this.nome_projeto_edit
                 },  
                    this.headers()
                )
                .then(response => {
                    this.nome_projeto = response.data.nome_projeto;
                    this.$bvToast.toast("O nome do projeto foi atualizado!", {
                        title: 'Sucesso',
                        variant: 'success',
                        solid: true
                    });
                    this.$bvModal.hide('projectNameModal')
                })
                .catch((err) => {
                    if(err.response){
                        this.$bvToast.toast(err.response.data.message, {
                        title: 'Erro ao atualizar informações',
                        variant: 'danger',
                        solid: true
                        });
                    }
                    this.$bvModal.hide('projectNameModal')
                });
            },

            headers() {
                const token = this.$store.getters['auth/token'].token
                const headers = { headers: { Authorization: 'Bearer ' + token }}
                return headers;
            },
        }

    }
</script>


